var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.products),function(product,idx){return _c('span',{key:product.id},[_c('router-link',{attrs:{"to":{ name: 'View Product', params: { id: product.id } }}},[_vm._v(" "+_vm._s(`${product.name}`)+" ")]),_vm._v(" "+_vm._s(_vm.products.length - 1 > idx ? "," : " ")),_c('br')],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }